import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRecurrencesModule } from './dialog/dialog-recurrences.module';
import { FilterRecurrencesModule } from './filter/filter-recurrences.module';
import { RecurrencesComponent } from './recurrences.component';
import { RecurrenceQueries } from './services/recurrence.queries';
import { RecurrenceService } from './services/recurrence.service';

const routes: Routes = [
  {
    path: 'recorrencias',
    component: RecurrencesComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.RECURRENCES' }
  }
];

@NgModule({
  declarations: [
    RecurrencesComponent
  ],
  imports: [
    RouterModule.forChild(routes),

    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,

    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatProgressSpinnerModule,

    FilterRecurrencesModule,
    DialogRecurrencesModule,
    ExportDialogModule
  ],
  exports: [
    RecurrencesComponent
  ],
  providers: [
    RecurrenceService,
    RecurrenceQueries
  ]
})
export class RecurrencesModule { }
